'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

var _map = require('unmutable/lib/map');

var _map2 = _interopRequireDefault(_map);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (iteratee) {
    return function (parcelData) {
        (0, _pipeWith2.default)(parcelData.value, (0, _map2.default)(function (ii, key) {
            iteratee((0, _get2.default)(key)(parcelData), key);
        }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/forEach.js
// module id = 747
// module chunks = 35783957827783